import React, { useState } from 'react';

import { 
  Character,
  CharacterAbility,
  CharacterExtraEffects,
  CharacterSheetInterface,
  CharacterSpell,
} from "@dndModels";

import CharacterResourceBoxes from "@dndComponents/character/misc/CharacterResourceBoxes";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  obj: CharacterSpell | CharacterAbility | CharacterExtraEffects;
  level?: number;
  shared: boolean;
  onChange: () => void;
}

/**
 * Pass it a CharacterSpell, CharacterAbility, or CharacterExtraEffects, and it will give the ResourceBoxes for it
 */
export default function CharacterResourceBoxesFor({ 
  character,
  char_interface,
  obj,
  level: true_level = -1,
  shared,
  onChange,
}: Props) {
  const [ping, setPing] = useState(false);
  
  let resource_consumed = "None";
  let item_id = "";
  let special_resource_amount = 0;
  let level = true_level;
  if (obj instanceof CharacterSpell) {
    resource_consumed = "Slot";
    if (level === -1) {
      level = obj.level;
    }
  } else if (obj instanceof CharacterAbility) {
    item_id = obj.char_feature?.use_item_id ?? "";
    special_resource_amount = obj.special_resource_amount;
    if (level === -1) {
      level = obj.level;
    }
    const the_ability = obj.the_ability;
    if (the_ability) {
      resource_consumed = the_ability.resource_consumed;
    }
  } else { 
    item_id = obj.item_id;
    special_resource_amount = obj.special_resource_amount;
    // if (level === -1) {
    //   level = obj.level;
    // }
    resource_consumed = obj.resource_consumed;
  }
  if (resource_consumed === "Slot") {
    const slot = character.use_slots.find(o => o.level === level);
    if (slot) {
      return (
        <CharacterResourceBoxes 
          used={slot.used}
          total={slot.total}
          true_total={slot.true_total}
          created={slot.created}
          type={slot.slot_name}
          show_type={false}
          character={character}
          shared={shared}
          onChange={(used: number) => {
            slot.used = used;
            // slot.total = total;
            // slot.true_total = true_total;
            // slot.created = created;
            onChange();
            setPing(!ping);
          }}
          // resource={slot}
          // character={character}
          // onChange={() => {
          //   onChange(["Resources"]);
          // }}
        />
      );
    }
  } else if (resource_consumed === "Special") {
    const old_used = char_interface.resource_holder.getSpecialResourceUsed(obj.true_id);
    return (
      <CharacterResourceBoxes 
        used={old_used}
        total={special_resource_amount}
        true_total={special_resource_amount}
        created={0}
        type={obj.name}
        show_type={false}
        character={character}
        shared={shared}
        onChange={(used: number) => {
          char_interface.resource_holder.setSpecialResourceUsed(obj.true_id, used);
          onChange();
          setPing(!ping);
        }}
      />
    );
  } else if (resource_consumed === "Charge") {
    const char_item = character.items.find(o => o.true_id === item_id);
    if (char_item) {
      // Make this work more like with a spell
      return (
        <CharacterResourceBoxes 
          used={char_item.charges_used}
          total={char_item.max_charges}
          true_total={char_item.max_charges}
          created={0}
          type={"Charge"}
          show_type={false}
          character={character}
          shared={shared}
          onChange={(used: number) => {
            char_item.charges_used = used;
            setPing(!ping);
            onChange();
          }}
        />
      );
    }
  } else if (resource_consumed !== "None" && resource_consumed !== "") {
    const crf = character.resources.find(o => o.type_id === resource_consumed);
    if (crf) {
      return (
        <CharacterResourceBoxes 
          used={crf.used}
          total={crf.total}
          true_total={crf.true_total}
          created={crf.created}
          type={crf.name}
          show_type={true}
          character={character}
          shared={shared}
          onChange={(used: number) => {
            crf.used = used;
            setPing(!ping);
            onChange();
          }}
        />
      );
    }
  }
  return <></>;
}
